import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import WorkflowMessagePanel from '../WorkflowMessagePanel';
import { Utils } from '../../services';
import { findMessageShowBrickForEndScreen, resolveMessageShowHtml } from '../../services/workflowMessageShowUtils';

const MessageShowEndScreen = ({ workflow, containerRef, fallbackMainHtml = '' }) => {
    const { i18n } = useTranslation();
    const lang = Utils.i18nUiLang(i18n);

    const mainHtml = useMemo(() => {
        const context = workflow?.context || {};
        const brick = findMessageShowBrickForEndScreen(workflow);
        if (brick) {
            const resolved = resolveMessageShowHtml(brick, context, lang);
            if (resolved)
                return resolved;
        }
        return fallbackMainHtml || '';
    }, [workflow, lang, fallbackMainHtml]);

    if (!mainHtml)
        return <div className="WorkflowRunner WorkflowRunner--completed" ref={containerRef} />;

    return (
        <div className="WorkflowRunner WorkflowRunner--completed" ref={containerRef}>
            <WorkflowMessagePanel mainHtml={mainHtml} />
        </div>
    );
};

export default MessageShowEndScreen;
